/** biome-ignore-all lint/nursery/useExplicitType: Zod schema inference */
import { z } from 'zod';
import { collectionSubtitleStatusSchema } from './collection-subtitle-status';

export const collectionSubtitleSchema = z.object({
  id: z.number(),
  collectionId: z.number(),
  filename: z.string(),
  srtParsed: z.string(),
  entryCount: z.number(),
  durationMs: z.number(),
  status: collectionSubtitleStatusSchema,
  vaultPath: z.string().nullable(),
  errorMessage: z.string().nullable(),
  createdAt: z.number(),
  updatedAt: z.number(),
});

export type ICollectionSubtitle = z.infer<typeof collectionSubtitleSchema>;

export const linkedChallengeSchema = z.object({
  challengeId: z.number(),
  challengeTitle: z.string().nullable(),
  published: z.boolean(),
  entryIndices: z.array(z.number()),
});

export type ILinkedChallenge = z.infer<typeof linkedChallengeSchema>;

export const collectionSubtitleDetailSchema = collectionSubtitleSchema.extend({
  linkedChallenges: z.array(linkedChallengeSchema).optional(),
});

export type ICollectionSubtitleDetail = z.infer<typeof collectionSubtitleDetailSchema>;

export const collectionSubtitleListItemSchema = collectionSubtitleSchema.omit({
  srtParsed: true,
});

export type ICollectionSubtitleListItem = z.infer<typeof collectionSubtitleListItemSchema>;

export const collectionSubtitleListItemWithCollectionSchema =
  collectionSubtitleListItemSchema.extend({
    collectionTitle: z.string(),
    collectionSlug: z.string(),
    challengeCount: z.number(),
  });

export type ICollectionSubtitleListItemWithCollection = z.infer<
  typeof collectionSubtitleListItemWithCollectionSchema
>;
